import { render } from "./PrintBankDetailsBlock.vue?vue&type=template&id=1ce24ca5"
import script from "./PrintBankDetailsBlock.vue?vue&type=script&lang=js"
export * from "./PrintBankDetailsBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__